<div class="schema-table-data" *ngIf="loadTable">
  <nz-table #basicTable [nzData]="data"
  [nzPaginationPosition]="'bottom'"
  [nzShowQuickJumper]="showQuickJumper"
  [nzSimple]="false"
  [nzPageSize]="pageSize"
  [nzSize]="rowSize">
    <thead (nzSortChange)="onSort($event)" nzSingleSort>
      <tr>
        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.sort; else defaultHeader" nzShowSort nzSortKey="col.key">{{col.title}}</th>
          <ng-template #defaultHeader> <th>{{col.title}}</th></ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let dt of basicTable.data">
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.type==='link'; else defaultData"><a (click)="onRowCellClick(col, dt)">{{dt[col.key]}}</a></td>
          <ng-template #defaultData> <td>{{dt[col.key]}}</td></ng-template>
        </ng-container>
      </tr>
    </tbody>
  </nz-table>
</div>
